/* jshint esversion: 6 */
import React from 'react';
import DropDownModule from 'app/mixins/DropDownModule.js';
import classnames from 'classnames';

class FeedItem extends React.Component {
    constructor(props) {
        super(props);

        this.viewFeed = this.viewFeed.bind(this);
        this.onImgError = this.onImgError.bind(this);

	}

	viewFeed(e) {
		// keep the 'view' click from triggering adding a feed
		e.stopPropagation();

		let onboarding = (typeof(Storage) !== undefined) ? JSON.parse(window.localStorage.getItem('onboarding')) : null;

		if (onboarding !== null) {
			if (mixpanel !== undefined) {
				mixpanel.track("Onboarding - View Feed Clicked");
			}
		}
	 }

    onImgError(e) {

        this.setState({
            iconImageValid: false
        });

    }

    render() {
        let itemIcon = null,
            itemClass = classnames('feed-search-item', {'active-item': this.props.itemActive}),
            iconUrl = this.props.item.iconUrl;

        if (iconUrl && iconUrl.match('http://')) {
            iconUrl = iconUrl.replace('http://', 'https://');
        }

		itemIcon = (
			<div className="inline-icon"/>
		);
        if (this.props.item.iconUrl) {
            itemIcon = (
				<div className="inline-icon">
                	<img src={iconUrl} className="inline-icon-img" onError={this.onImgError}/>
            	</div>
			);
        }

		let viewUrl = this.props.item.url;

        return (
			<li key={this.props.key} className={itemClass} onClick={this.props.onClick} role="switch" aria-label="add feed">
	            {itemIcon}
	            <div className="feed-search-item-title">
	                <span className="feed-title">{this.props.item.title}</span>
	                <a href={viewUrl} className="feed-search-preview" onClick={this.viewFeed} target="_blank">
	                    view
					</a>
	            </div>
	            <div className="add-feed-button">
	                <i className="fa fa-plus"></i>
	            </div>
        	</li>
		);
    }
};

export default DropDownModule(FeedItem);
